module.exports = __webpack_public_path__ + "media/icons/sharing_history-9050e9af.svg";